import { Operator, Property } from '../models/RuleEngineConfig';

const WEIGHT_MEASURING_UNITS = ['kg', 'lb', 'oz', 'g'];

export enum TimeFrame {
  WITHIN_LAST_DAYS = 'within_the_last',
  ALL_TIME = 'all_time',
}
const TIME_FRAMES = [TimeFrame.ALL_TIME, TimeFrame.WITHIN_LAST_DAYS];

export interface DropdownOption {
  label: string;
  value: string;
}

export interface PropertyOperatorMapping {
  property: Property;
  operators: Operator[];
  dropdownOptions?: DropdownOption[];
  placeholder?: string;
}

const NUMERIC_OPERATORS = [
  Operator.equals,
  Operator.not_equals,
  Operator.is_less_than,
  Operator.is_more_than,
  Operator.is_less_than_or_equal_to,
  Operator.is_more_than_or_equal_to,
];

const BOOLEAN_OPERATORS = [Operator.is, Operator.is_not];
const SELECTION_OPERATORS = [...BOOLEAN_OPERATORS, Operator.is_only];
const TEXT_OPERATORS = [...BOOLEAN_OPERATORS, Operator.contains, Operator.not_contains];

const mapArrToDropdownOptions = (arr: string[]): DropdownOption[] =>
  arr.map((opt) => ({ label: opt.replace(/_/g, ' '), value: opt }));

export const PROPERTY_OPERATOR_MAPPING: PropertyOperatorMapping[] = [
  {
    property: Property.cartValue,
    operators: NUMERIC_OPERATORS,
  },
  {
    property: Property.customerOrderCount,
    operators: NUMERIC_OPERATORS,
    dropdownOptions: mapArrToDropdownOptions(TIME_FRAMES),
  },
  {
    property: Property.weight,
    operators: NUMERIC_OPERATORS,
    dropdownOptions: mapArrToDropdownOptions(WEIGHT_MEASURING_UNITS),
  },
  {
    property: Property.vendor,
    operators: SELECTION_OPERATORS,
  },
  {
    property: Property.collection,
    operators: SELECTION_OPERATORS,
  },
  {
    property: Property.productType,
    operators: SELECTION_OPERATORS,
  },
  {
    property: Property.shopify_tags,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.customerTag,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.country,
    operators: BOOLEAN_OPERATORS,
  },
  {
    property: Property.subscription,
    operators: SELECTION_OPERATORS,
  },
  {
    property: Property.source,
    operators: SELECTION_OPERATORS,
  },
  {
    property: Property.customerSpend,
    operators: NUMERIC_OPERATORS,
  },
  {
    property: Property.weekday,
    operators: BOOLEAN_OPERATORS,
  },
  {
    property: Property.hasACoupon,
    operators: BOOLEAN_OPERATORS,
  },
  {
    property: Property.grossMargin,
    operators: NUMERIC_OPERATORS,
    dropdownOptions: [{ label: '%', value: 'percentage' }],
  },
  {
    property: Property.gender,
    operators: BOOLEAN_OPERATORS,
  },
  {
    property: Property.productMetafield,
    operators: SELECTION_OPERATORS,
    placeholder: 'namespace.key:value',
  },
  {
    property: Property.variantMetafield,
    operators: SELECTION_OPERATORS,
    placeholder: 'namespace.key:value',
  },
  {
    property: Property.variantTitle,
    operators: TEXT_OPERATORS,
    placeholder: 'Example: Small / Red',
  },
  {
    property: Property.sellingPlan,
    operators: [Operator.is_any, Operator.is_all],
    placeholder: 'Selling plan ID',
  },
  {
    property: Property.cartAttributeKey,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.cartAttributeValue,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.propertiesValue,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.propertiesKey,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.locale,
    operators: TEXT_OPERATORS,
  },
  {
    property: Property.timeOfDay,
    operators: BOOLEAN_OPERATORS,
  },
];
